/*
 *
 *   reducer
 *
 */
import { produce } from "immer";

import {
  LOAD_PAYMENT_IN_DETAILS_SUCCESS,
  LOAD_PAYMENT_IN_DETAILS_ERROR,
  LOAD_PAYMENT_SETTLED_LIST_SUCCESS,
  LOAD_PAYMENT_SETTLED_LIST_ERROR,
  LOAD_PAYMENT_IN_DETAILS_RECORDS_META_DATA_SUCCESS,
  LOAD_PAYMENT_IN_DETAILS_RECORDS_META_DATA_ERROR,
  CREATE_PAYMENT_IN_DETAILS_SUCCESS,
  CREATE_PAYMENT_IN_DETAILS_ERROR,
  UPDATE_PAYMENT_IN_DETAILS_SUCCESS,
  UPDATE_PAYMENT_IN_DETAILS_ERROR,
  DELETE_PAYMENT_IN_DETAILS_SUCCESS,
  DELETE_PAYMENT_IN_DETAILS_ERROR,
  LOAD_PARTY_ACCOUNT_LIST_SUCCESS,
  LOAD_PARTY_ACCOUNT_LIST_ERROR,
  LOAD_PAYMENT_IN_DETAILS_REPORT_SUCCESS,
  LOAD_PAYMENT_IN_DETAILS_REPORT_ERROR,
} from "./constants";

const initialState = {
  payment_in_list: [],
  payment_in_report: [],
  payment_settled_list: [],
  party_account_list: [],
  record: {},
  records: {},
  recordsMetaData: {},
  loading: false,
  error: false,
  success: false,
  lastUpdate: null,
};

const Reducer = (
  state = initialState,
  {
    type,
    payment_in_report,
    payment_in_list,
    party_account_list,
    payment_settled_list,
    record,
    recordsMetaData = {},
    error,
    success,
  }
) => {
  return produce(state, (draft) => {
    switch (type) {
      // case LOAD_RECORDS_VALID_CACHE:
      //   draft.loading = false;
      //   draft.error = false;
      //   draft.success = false;
      //   break;
      case LOAD_PAYMENT_IN_DETAILS_SUCCESS:
        draft.payment_in_list = payment_in_list;
        draft.loading = false;
        draft.error = false;
        draft.success = false;
        break;
      case LOAD_PAYMENT_IN_DETAILS_REPORT_SUCCESS:
        draft.payment_in_report = payment_in_report;
        draft.loading = false;
        draft.error = false;
        draft.success = false;
        break;
      case LOAD_PAYMENT_SETTLED_LIST_SUCCESS:
        draft.payment_settled_list = payment_settled_list;
        draft.loading = false;
        draft.error = false;
        draft.success = false;
        break;
      case LOAD_PARTY_ACCOUNT_LIST_SUCCESS:
        draft.party_account_list = party_account_list;
        draft.loading = false;
        draft.error = false;
        draft.success = false;
        break;
      case CREATE_PAYMENT_IN_DETAILS_SUCCESS:
        draft.record = [record].concat(state.record);
        draft.loading = false;
        draft.error = false;
        draft.success = success;
        break;
      case UPDATE_PAYMENT_IN_DETAILS_SUCCESS:
        draft.record = [record].concat(state.record);
        draft.error = false;
        draft.success = success;
        break;
      case DELETE_PAYMENT_IN_DETAILS_SUCCESS:
        draft.record = record;
        draft.error = false;
        draft.success = success;
        break;

      case LOAD_PAYMENT_IN_DETAILS_RECORDS_META_DATA_SUCCESS:
        draft.recordsMetaData = recordsMetaData;
        draft.error = false;
        draft.success = success;
        break;

      case LOAD_PAYMENT_IN_DETAILS_ERROR:
      case CREATE_PAYMENT_IN_DETAILS_ERROR:
      case UPDATE_PAYMENT_IN_DETAILS_ERROR:
      case DELETE_PAYMENT_IN_DETAILS_ERROR:
      case LOAD_PARTY_ACCOUNT_LIST_ERROR:
      case LOAD_PAYMENT_SETTLED_LIST_ERROR:
      case LOAD_PAYMENT_IN_DETAILS_REPORT_ERROR:
        draft.loading = false;
        draft.error = error;
        draft.success = false;
        break;

      case LOAD_PAYMENT_IN_DETAILS_RECORDS_META_DATA_ERROR:
        draft.error = error;
        draft.success = false;
        break;
      default:
        return state;
    }
  });
};

export default Reducer;
